import { createContext } from "react";
import { Transaction } from "../../interfaces/data";

interface TransactionContextInterface {
  transaction?: Transaction;
  setTransaction: (data?: Transaction) => void;
}

export default createContext({} as TransactionContextInterface);
